import Vue from 'vue';
import Router from 'vue-router';
import multiGuard from 'vue-router-multiguard';

import store from './store';
import socket from './services/socket';
import notificator from './services/notificator';
import home from './views/home';
import lobby from './views/lobby';
import userLogin from './views/auth/login';
import userRegister from './views/auth/register';
import forgotPassword from './views/auth/forgot-password';
import resetPassword from './views/auth/reset-password';
import profile from './views/auth/profile';
import changePassword from './views/auth/change-password';
import game from './views/game';

Vue.use(Router);

function disallowAuth(to, from, next) {
  store.getters['auth/isAuth'] ? next({ name: 'lobby' }) : next();
}

function disallowGuest(to, from, next) {
  if (store.getters['auth/isAuth']) {
    next();
  } else {
    notificator.info('Please log in first to proceed.');

    next({ name: 'userLogin' });
  }
}

function rememberGameId(to, from, next) {
  store.commit('auth/setGameId', to.params.id);

  next();
}

function clearGameId(to, from, next) {
  store.commit('auth/setGameId', null);

  next();
}

async function fetchGameState(to, from, next) {
  await store.dispatch('fetchGameState', to.params.id);

  store.getters['getGameState'].id ? next() : next({ name: 'lobby' });
}

async function fetchGames(to, from, next) {
  await store.dispatch('lobby/fetchGames');

  next();
}

// TODO: dedupe
function fetchLobbyMessages(to, from, next) {
  socket.emitFetchMessages('lobby');

  next();
}

// TODO: dedupe
function joinLobbyRoom(to, from, next) {
  socket.emitJoinRoom('lobby');

  next();
}

// TODO: dedupe
function fetchGameMessages(to, from, next) {
  socket.emitFetchMessages(to.params.id);

  next();
}

// TODO: dedupe
function joinGameRoom(to, from, next) {
  socket.emitJoinRoom(to.params.id);

  next();
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: home,
    meta: {
      isScrollable: true,
    },
  },
  {
    path: '/login',
    name: 'userLogin',
    component: userLogin,
    beforeEnter: disallowAuth,
  },
  {
    path: '/register',
    name: 'userRegister',
    component: userRegister,
    beforeEnter: disallowAuth,
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    component: forgotPassword,
    beforeEnter: disallowAuth,
  },
  {
    path: '/reset-password/:token',
    name: 'resetPassword',
    component: resetPassword,
    beforeEnter: disallowAuth,
  },
  {
    path: '/profile',
    name: 'userProfile',
    component: profile,
    beforeEnter: disallowGuest,
  },
  {
    path: '/change-password',
    name: 'changePassword',
    component: changePassword,
    beforeEnter: disallowGuest,
  },
  {
    path: '/lobby',
    name: 'lobby',
    component: lobby,
    beforeEnter: multiGuard([disallowGuest, fetchGames, fetchLobbyMessages, joinLobbyRoom]),
  },
  {
    path: '/:id(GAME-[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})',
    name: 'game',
    component: game,
    meta: { isFooterInfoHidden: true },
    beforeEnter: multiGuard([
      rememberGameId,
      disallowGuest,
      clearGameId,
      fetchGameState,
      fetchGameMessages,
      joinGameRoom,
    ]),
  },
  { path: '*', redirect: { name: 'home' } },
];

const router = new Router({
  mode: 'history',

  base: process.env.BASE_URL,
  routes: routes,
});

router.beforeEach(async (to, from, next) => {
  await store.dispatch('auth/tryAutoLogin');

  socket.init(to);

  next();
});

export default router;
